import {AbstractModel} from '../abstract-model';

export class LeadOverview extends AbstractModel {
  lead: number = 0;
  averageRevenue: number = 0;
  totalSales: number = 0;
}
